import { api } from "./api"
export const postCidade = (situation: any) => api.post(`Cidade/incluir/`, situation);
export const getCidades = async (numeroPagina: string, registrosPorPagina: string, ordem: string) => {
  try {
    const response = await api.get(`Cidade/buscartodos/${numeroPagina}/${registrosPorPagina}/${ordem}`);
    return response.data;
  } catch (error) {
    console.error(error);
  }
};
export const getTodasCidades = async () => {
  try {
    const response = await api.get(`Cidade/select`)
    return response.data;
  } catch (error) {
    console.error(error);
  }
};
export const getCidade = (cdCidade: string) => api.get(`Cidade/buscar/${cdCidade}`);
export const putCidade = (cidade: any) => api.put(`Cidade/alterar/`, cidade);
export const deleteCidade = (data: any) => api.delete(`Cidade/excluir`, { data });
export const postFiltrarCidade = async (filtro: { [key: string]: string }, numeroPagina: string, registrosPorPagina: string, ordem: string) => {
  try {
    const response = await api.post(`Cidade/filtrar/${numeroPagina}/${registrosPorPagina}/${ordem}`, filtro);
    return response.data;
  } catch (error) {
    console.error(error);
  }
}
